module.exports = __webpack_public_path__ + "static/media/1-Attal-mobile.f28fd3d6.webp";